import { memo } from 'react';

import { ImagesIcon } from '@air/design-icons';

import { NullState } from '~/components/NullState';

/** No upload or create actions: the list is the agent's snapshot, not a place to add content. */
export const WorkspaceAgentAssetListNullState = memo(() => (
  <NullState
    description="The agent didn't return any assets we can show."
    icon={ImagesIcon}
    testId="WORKSPACE_AGENT_ASSET_LIST_EMPTY"
    title="No assets in this list"
  />
));

WorkspaceAgentAssetListNullState.displayName = 'WorkspaceAgentAssetListNullState';
